import { t } from 'ttag';

import { Nullable } from '../../types/general';
import { DocumentFieldType } from './enums';
import {
    DocumentField,
    DocumentParameter,
    DocumentSettingParameter,
} from './types';

const validateNewField = (newField: DocumentField): string[] => {
    const errors: string[] = [];

    if (!newField.name) errors.push(t`Заповніть поле "Назва параметру"`);
    if (!newField.type) errors.push(t`Заповніть поле "Тип параметру"`);
    if (
        newField.type === DocumentFieldType.enum &&
        (!newField.enumOptions ||
            (newField.enumOptions.length === 1 &&
                newField.enumOptions[0] === ''))
    ) {
        errors.push(t`Заповніть поле "Варіанти переліку"`);
    }

    return errors;
};

export const validateSaveNewFields = (
    newFields: DocumentField[],
): Record<string, string[]> => {
    const errorsMap: Record<string, string[]> = {};

    newFields.forEach((newField) => {
        const errors = validateNewField(newField);
        if (errors.length > 0) {
            errorsMap[newField.id] = errors;
        }
    });

    return errorsMap;
};

export const validateDocumentParametersValues = (
    documentFields: DocumentField[],
    documentParameters: DocumentParameter[],
): Nullable<DocumentSettingParameter[]> => {
    documentParameters.forEach((parameter) => {
        if (parameter.isRequired && !parameter.value) {
            throw Error(t`Заповніть обов'язкові додаткові параметри`);
        }
    });

    // Remove old fields to pass backend validation
    const fieldsIds = documentFields.map((field) => field.id);
    return documentParameters
        .filter((parameter) => fieldsIds.includes(parameter.fieldId))
        .map((parameter) => ({
            field_id: parameter.fieldId,
            is_required: parameter.isRequired || false,
            value: parameter.value || null,
        }));
};
